import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import { createRoot } from "react-dom/client";
// import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { SWRConfig } from "swr";
import App from "./App";
import { VideoProvider } from "./components/VideoProvider";
import { VRIAppStore } from "./core";
import reportWebVitals from "./reportWebVitals";
import "./scss/style.scss";
import AppStateProvider, { useAppState } from "./state";
import useConnectionOptions from "./utils/video/useConnectionOptions/useConnectionOptions";
import { Amplify } from 'aws-amplify';
import "./core/Amplify/appsyncClient";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_API,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});


const VriApp = () => {
  const { setError } = useAppState();
  const connectionOptions = useConnectionOptions();

  return (
    <Provider store={VRIAppStore}>
      <VideoProvider options={connectionOptions} onError={setError}>
        <App />
      </VideoProvider>
    </Provider>
  );
};

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
};

const theme = process.env.REACT_APP_THEME || "purple";
const storedMode = window.localStorage.getItem("theme-mode");
const hasUserSetMode = window.localStorage.getItem("theme-mode-user-set") === "1";
const isDarkModeEnabled = process.env.REACT_APP_ENABLE_DARK_MODE === "true";
const mode = isDarkModeEnabled
  ? (hasUserSetMode ? (storedMode || "light") : (process.env.REACT_APP_MODE || "light"))
  : "light";
document.documentElement.setAttribute("data-theme", theme);
document.documentElement.setAttribute("data-mode", mode);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <AppStateProvider>
      <SWRConfig value={swrOptions}>
        <VriApp />
      </SWRConfig>
    </AppStateProvider>
  </React.StrictMode>
);
reportWebVitals();
